import { creatorbase } from '@round/api';
import styles from './PostUrlLink.module.css';

type PostUrlLinkProps = {
    url: string | undefined;
    className?: string;
    children?: React.ReactNode;
};

export const PostUrlLink = ({ url, className, children }: PostUrlLinkProps) => {
    if (!url) {
        return <>{children || url}</>;
    }

    return (
        <a href={url} target="_blank" rel="noopener noreferrer" className={className || styles.urlLink}>
            {children || url}
        </a>
    );
};

export const getPostUrl = (post: creatorbase.Post & { requested_url?: string }): string | undefined => {
    return post.requested_url || post.post_url;
};
